import promotionValue from "./promotionValue.component";

const promotionValueModule = angular
  .module("app.components.promotionValue", [])
  .component("promotionValue", promotionValue);

export default promotionValueModule;



// WEBPACK FOOTER //
// ./src/components/promotionValue/promotionValue.module.js